"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticResourcesClient = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");

var _constants = require("../constants");

var StaticResourcesClient = {
  getStaticResources: function getStaticResources() {
    var requestId = 'STATIC_RESOURCES';
    var endpoint = _constants.ENDPOINTS.STATIC_RESOURCES;
    return _http.$http.get(requestId, endpoint).then(function (_ref) {
      var data = _ref.data,
          headers = _ref.headers;
      return (0, _objectSpread2.default)({}, data, {
        headers: headers
      });
    });
  }
};
exports.StaticResourcesClient = StaticResourcesClient;